// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"34234942","361":"6ae9a29a","767":"0c394a7c"}[chunkId] + ".chunk.js";
};